import {Base} from "@/api/Base"

export class AdvisorDelete extends Base {
    path = "advisor/delete"
}